import PaymentResultPagePresenter from "@/features/payment/components/payment-result-page-presenter";

export default function PaymentPage() {
  return (
    <PaymentResultPagePresenter />
  );
}
